'use client'
import { usePathname } from 'next/navigation'

const useClickWithScroll = () => {
  let itemIndex = null
  let isMenuOpen = false

  const pathname = usePathname()
  const isHomePage = pathname === '/'

  const onClickItem = (path, index) => {
    itemIndex = index
    scrollTo(path)
  }

  const scrollTo = (path) => {
    const element = document.getElementById(path)

    if (element) {
      const elementPosition =
        element.getBoundingClientRect().top + window.pageYOffset
      const offsetPosition = Math.min(
        elementPosition,
        document.body.scrollHeight - window.innerHeight
      )

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      })

      window.dispatchEvent(new Event('scroll'))
    }
  }

  return {
    isHomePage,
    scrollTo,
    itemIndex,
    onClickItem,
    menu: {
      isOpen: isMenuOpen
    }
  }
}

export default useClickWithScroll
